import { httpClient } from "@/services";
import getUniqId from "@/helper/getUniqId";
import getDefaultDate from "@/helper/getDefaultDate";

export default {
	state: {
		trucksRoadList: null,
		trucksRoadFilter: null,
		reason: [],
		trucksRoadData: null,
		dispatcherApproved: false,
		fleetApproved: false,
		datesColor: null,
		dateFilter: null,
		isDateFilter: null,
		isRefreshDate: null,
		isRefreshFilter: null,
		trucksOnTheRoad: null,
		generateTrucksInvoices: { list: [], total: {}, status: {} }
	},
	mutations: {
		updateTrucksRoad(state, {
			filter,
			list,
			reason,
			dispatcher_approved,
			fleet_approved,
			dates,
			date,
			isRefreshDate,
			emails
		}) {
			state.trucksRoadList = list;
			state.trucksRoadFilter = filter;
			state.reason = reason;
			state.datesColor = dates;
			if (!isRefreshDate) state.dateFilter = date;
			state.dispatcherApproved = Boolean(dispatcher_approved);
			state.fleetApproved = Boolean(fleet_approved);
			state.trucksOnTheRoad = emails;
		},
		updateDatesColor(state, { dates }) {
			state.datesColor = dates;
		},
		updateTrucksRoadCreate(state, payload) {
			state.trucksRoadData = payload;
		},
		updateGenerateTrucksInvoices(state, payload) {
			state.generateTrucksInvoices = payload;
		},
		updateDateFilter(state, values) {
			if (values === null) {
				state.dateFilter = getDefaultDate();
				state.isDateFilter = values;
			} else {

				const { from, to } = values;
				state.isDateFilter = from === to;

				if (state.isDateFilter) {
					state.dateFilter = from;
				}
			}
		},
		updateRefresh(state) {
			state.isRefreshDate = getUniqId();
		},
		updateFilterRefresh(state) {
			state.isRefreshFilter = getUniqId();
		}
	},
	actions: {
		async onTrucksRoad({ commit, dispatch }) {
			dispatch('actionPreloader', true);
			try {
				const { data } = await httpClient.get('/truck-road');
				if (data && !data.status) {
					commit('updateTrucksRoad', data);
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadFilter({ commit, dispatch }, { filters, isRefreshDate }) {
			dispatch('actionPreloader', true);
			try {
				const { data } = await httpClient.post('/truck-road/list', filters);
				if (data && !data.status) {
					data.isRefreshDate = isRefreshDate;
					commit('updateTrucksRoad', data);
				}
				dispatch('actionPreloader', false);
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadSave({ dispatch }, payload) {
			try {
				const { data } = await httpClient.post('/truck-road', payload);
				if (data && !data.error) {
					await dispatch('onTrucksRoad');
					dispatch('setAlert', { type: "success", message: "Item added successfully" });
				} else {
					const { error: { drive_type_id, truck_id } = {} } = data || {};
					dispatch('setAlert', {
						type: "error",
						message: drive_type_id?.toString() || truck_id?.toString() || "Saving error"
					});
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onGenerateTrucksInvoices({ commit, dispatch }, payload) {
			try {
				const { data } = await httpClient.post('/truck-road/generate', payload);
				if (data && !data.status) {
					dispatch('setAlert', { type: "error", message: "Report couldn't send" });
				} else {
					commit('updateGenerateTrucksInvoices', data);
					dispatch('setAlert', { type: "success", message: "Report was sent successfully" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onSendTrucksInvoices({ dispatch }, payload) {
			try {
				const { data } = await httpClient.post('/truck-road/send', payload);
				if (data && !data.status) {
					dispatch('setAlert', { type: "error", message: "Report couldn't send" });
				} else {
					dispatch('setAlert', { type: "success", message: "Report was sent successfully" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadCreate({ commit }) {
			try {
				const { data } = await httpClient.get("/truck-road/create");
				if (data && !data.status) {
					commit('updateTrucksRoadCreate', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadEditDynamic({ dispatch }, { id, ...values }) {
			try {
				const { data } = await httpClient.put(`/truck-road/${ id }`, values);

				if (data && !data.status) {
					dispatch('setAlert', { type: "success", message: "Item saved successfully" });
					return 1;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadDelete({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/truck-road/${ id }`);
				if (data) {
					await dispatch('onTrucksRoad');
					dispatch('setAlert', { type: "success", message: "Item deleted successfully" });
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadExport({ dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/truck-road/export", filters);
				if (data) {
					dispatch("actionPreloader", false);
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadRefresh({ dispatch, commit }, refreshData) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/truck-road/refresh", refreshData);
				if (data.status) {
					commit('updateDatesColor', data);
					dispatch('setAlert', { type: "success", message: "Data updated successfully" });
				} else {
					dispatch('setAlert', { type: "error", message: "Something went wrong" });
				}
				dispatch("actionPreloader", false);

			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadUpdateTrucks() {
			try {
				const { data } = await httpClient.post("/truck-road/updateTrucks");
				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadSend() {
			try {
				return await httpClient.get("/truck-road/send");
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksRoadApproved(context, value) {
			try {
				return await httpClient.post("/truck-road/approved", value);
			} catch (e) {
				console.error(e);
			}
		},
		onRefresh({ commit }) {
			commit('updateRefresh');
		},
		onDateFilter({ commit }, values) {
			commit('updateDateFilter', values);
		},
		onFilterRefresh({ commit }) {
			commit('updateFilterRefresh');
		}
	},
	getters: {
		trucksRoadList: s => s.trucksRoadList,
		trucksRoadFilter: s => s.trucksRoadFilter,
		trucksRoadData: s => s.trucksRoadData,
		reason: s => s.reason,
		fleetApproved: s => s.fleetApproved,
		dispatcherApproved: s => s.dispatcherApproved,
		datesColor: s => s.datesColor,
		dateFilter: s => s.dateFilter,
		isDateFilter: s => s.isDateFilter,
		isRefreshFilter: s => s.isRefreshFilter,
		isRefreshDate: s => s.isRefreshDate,
		trucksOnTheRoad: s => s.trucksOnTheRoad,
		generateTrucksInvoices: s => s.generateTrucksInvoices,
	}
};
